import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import PropTypes from 'prop-types';
import LinearProgress from '@/components/ui-bridge/core/LinearProgress';

const CardList = ({ cards = [], hasMore, loadMore, Element, scrollParentRef }) => {
  return (
    <div ref={scrollParentRef} className="w-full h-full overflow-y-auto overflow-x-hidden">
      <InfiniteScroll
        pageStart={0}
        loadMore={() => loadMore()}
        hasMore={!!hasMore}
        loader={<LinearProgress style={{ top: '10px' }} key="progress" />}
        useWindow={false}
        getScrollParent={() => scrollParentRef?.current}
        threshold={150}
      >
        <ul className="flex flex-col m-0 py-[0.5em]! px-[1em]! overflow-hidden list-none">
          {cards.map((item, index) => (
            <li
              key={item?.data?.id || item?.id || item?.public_id || index}
              className="my-[0.3em] first:mt-0 last:mb-0 fade-in"
            >
              <Element data={item?.data || item} />
            </li>
          ))}
        </ul>
      </InfiniteScroll>
    </div>
  );
};

CardList.propTypes = {
  cards: PropTypes.array.isRequired,
  Element: PropTypes.elementType.isRequired,
  hasMore: PropTypes.bool,
  loadMore: PropTypes.func,
  scrollParentRef: PropTypes.object,
};

CardList.defaultProps = {
  hasMore: false,
  loadMore: () => {},
};

export default CardList;
